import styled from 'styled-components';

import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';

export const SuggestedAnswerPreview = styled.div`
  ${flexCentreAlignCss}
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
